import Model from './Model';

export default class FunnelResource extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'funnel-resources';
  }
}
